export enum DashboardActionType {
  GetReportUsage = 'DASHBOARD_GET_REPORT_USAGE',
  GetReportUsageSuccess = 'DASHBOARD_GET_REPORT_USAGE_SUCCESS',
  GetReportUsageFailure = 'DASHBOARD_GET_REPORT_USAGE_FAILURE',
  GetReportTimeline = 'DASHBOARD_GET_REPORT_TIMELINE',
  GetReportTimelineSuccess = 'DASHBOARD_GET_REPORT_TIMELINE_SUCCESS',
  GetReportTimelineFailure = 'DASHBOARD_GET_REPORT_TIMELINE_FAILURE',
  GetNpsScore = 'DASHBOARD_GET_NPS_SCORE',
  GetNpsScoreSuccess = 'DASHBOARD_GET_NPS_SCORE_SUCCESS',
  GetNpsScoreFailure = 'DASHBOARD_GET_NPS_SCORE_FAILURE',
  GetCareSourceNpsScore = 'DASHBOARD_GET_CARESOURCE_NPS_SCORE',
  GetCareSourceNpsScoreSuccess = 'DASHBOARD_GET_CARESOURCE_NPS_SCORE_SUCCESS',
  GetCareSourceNpsScoreFailure = 'DASHBOARD_GET_CARESOURCE_NPS_SCORE_FAILURE',
}